import { render, staticRenderFns } from "./Visit-Listing-Template.vue?vue&type=template&id=3064684b"
import script from "./Visit-Listing-Template.vue?vue&type=script&lang=js"
export * from "./Visit-Listing-Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports